export default "__VITE_ASSET__BNBFf707__"